/* eslint-disable no-nested-ternary */

import { useHistory, useParams } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { CARGO_CODES } from "constants/permissions";
import * as S from "./styles";
import NavCommon from "../../components/@navHeader";
import CampanhasFilled from "./components/CampanhasFilled";
import CreateCampanha from "./components/CreateCampanha";
import DetailCampanha from "./components/DetailCampanha";
import CampanhasCorretor from "./components/CampanhasCorretor";

const Campanhas = () => {
  const history = useHistory();

  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const cargos = {
    isCorretor: codigoCargo2013 === CARGO_CODES.CORRETOR,
    isGerenteVendas: codigoCargo2013 === CARGO_CODES.GERENTE_VENDAS,
    isSuperintendente: codigoCargo2013 === CARGO_CODES.SUPERINTENDENTE,
  };

  if (cargos.isCorretor) {
    return (
      <>
        <NavCommon
          breadcrumbs={[{ path: "/campanhas-criadas", name: "Oferta ativa" }]}
          onBack={() => {
            history.goBack();
          }}
          onChangeActionNew={() => history.push("/")}
        />
        <S.Content>
          <CampanhasCorretor />
        </S.Content>
      </>
    );
  }

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "/campanhas-criadas", name: "Oferta ativa" }]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/")}
      />
      <S.Content>
        <CampanhasFilled cargos={cargos} />
      </S.Content>
    </>
  );
};

const CreateCampanhas = () => {
  const history = useHistory();

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: "/campanhas-criadas", name: "Oferta ativa" },
          { path: "/criar-campanha", name: "Criar Campanha" },
        ]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/")}
      />
      <S.Content>
        <CreateCampanha />
      </S.Content>
    </>
  );
};

const CampanhasDetail = () => {
  const params: any = useParams();
  const history = useHistory();
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const cargos = {
    isCorretor: codigoCargo2013 === CARGO_CODES.CORRETOR,
    isGerenteVendas: codigoCargo2013 === CARGO_CODES.GERENTE_VENDAS,
    isSuperintendente: codigoCargo2013 === CARGO_CODES.SUPERINTENDENTE,
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: "/campanhas-criadas", name: "Oferta ativa" },
          {
            path: `/campanha/${params.id}`,
            name: "Dados da campanha",
          },
        ]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/campanhas-criadas")}
      />
      <S.Content>
        <DetailCampanha cargos={cargos} />
      </S.Content>
    </>
  );
};

export { Campanhas, CreateCampanhas, CampanhasDetail };
